module.exports = __webpack_public_path__ + "media/IceDragon.c498d8aa.mp3";